(ns frontend.intelligence.icon)

(defn view []
  [:img.intelligence-icon
   {:src "/img/favicon256x256.ico"}])
